import { render, staticRenderFns } from "./inventory_table.vue?vue&type=template&id=50064622&scoped=true"
import script from "./inventory_table.vue?vue&type=script&lang=js"
export * from "./inventory_table.vue?vue&type=script&lang=js"
import style0 from "./inventory_table.vue?vue&type=style&index=0&id=50064622&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50064622",
  null
  
)

export default component.exports